import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table, Button, InputGroup } from "react-bootstrap";
import toast from "react-hot-toast";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";

export const Regras = () => {
  const [regras, setRegras] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [alteradas, setAlteradas] = useState([]);
  const [novoServico, setNovoServico] = useState("");
  const [novoDocumento, setNovoDocumento] = useState("");

  const getDados = async () => {
    try {
      const [reg, tip] = await Promise.all([
        blogFetch.get("/sga/rules"),
        blogFetch.get("/sga/document-type"),
      ]);
      setRegras(reg.data);
      setTiposDocumento(tip.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getDados();
  }, []);

  const alternar = (tipoServico, doc) => {
    setRegras((atual) =>
      atual.map((r) =>
        r.tipoServico !== tipoServico
          ? r
          : {
              ...r,
              documentos: r.documentos.includes(doc)
                ? r.documentos.filter((d) => d !== doc)
                : [...r.documentos, doc],
            }
      )
    );
    setAlteradas((atual) => (atual.includes(tipoServico) ? atual : [...atual, tipoServico]));
  };

  const salvar = async (regra) => {
    try {
      await blogFetch.put("/sga/rules", regra);
      setAlteradas((atual) => atual.filter((t) => t !== regra.tipoServico));
      toast.success(`Regra de ${regra.tipoServico} salva.`);
    } catch (err) {
      toast.error("Erro ao salvar a regra.");
    }
  };

  const adicionarServico = async () => {
    const nome = novoServico.trim();
    if (!nome || regras.some((r) => r.tipoServico.toLowerCase() === nome.toLowerCase())) return;
    try {
      await blogFetch.post("/sga/service-type", { tipoServico: nome });
      setRegras((atual) => [...atual, { tipoServico: nome, documentos: [] }]);
      setNovoServico("");
    } catch (err) {
      toast.error("Erro ao adicionar o tipo de serviço.");
    }
  };

  const adicionarDocumento = async () => {
    const nome = novoDocumento.trim().toUpperCase();
    if (!nome || tiposDocumento.includes(nome)) return;
    try {
      await blogFetch.post("/sga/document-type", { tipo: nome });
      setTiposDocumento((atual) => [...atual, nome]);
      setNovoDocumento("");
    } catch (err) {
      toast.error("Erro ao adicionar o tipo de documento.");
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">Regras de Documentos</h3>

        <Row className="g-3 mb-4">
          <Col md={4}>
            <InputGroup>
              <Form.Control
                placeholder="Novo tipo de serviço"
                value={novoServico}
                onChange={(e) => setNovoServico(e.target.value)}
              />
              <Button variant="outline-primary" onClick={adicionarServico}>Adicionar</Button>
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup>
              <Form.Control
                placeholder="Novo tipo de documento"
                value={novoDocumento}
                onChange={(e) => setNovoDocumento(e.target.value)}
              />
              <Button variant="outline-primary" onClick={adicionarDocumento}>Adicionar</Button>
            </InputGroup>
          </Col>
        </Row>

        <div className="table-responsive">
          <Table bordered hover className="align-middle text-center">
            <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
              <tr>
                <th className="text-start">Tipo de serviço</th>
                {tiposDocumento.map((t) => <th key={t} className="text-nowrap">{t}</th>)}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {regras.map((r) => (
                <tr key={r.tipoServico}>
                  <td className="text-start fw-bold text-nowrap">{r.tipoServico}</td>
                  {tiposDocumento.map((t) => (
                    <td key={t}>
                      <Form.Check
                        type="switch"
                        className="d-inline-block"
                        checked={r.documentos.includes(t)}
                        onChange={() => alternar(r.tipoServico, t)}
                      />
                    </td>
                  ))}
                  <td>
                    <Button
                      size="sm"
                      disabled={!alteradas.includes(r.tipoServico)}
                      onClick={() => salvar(r)}
                    >
                      Salvar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
};
